import React from 'react';
import logo from '../images/logo1.png'

function Contact(){
    return (
        <div id='contact'>
            <img className="contact-logo" src={logo} />
            <h4 className='email'>Contact Us at likamona16@gmail.com</h4>
            <p className='statement'>Made with <i class="fa fa-heart"></i> by <a target="_blank" href="https://www.linkedin.com/in/monalika7/">Monalika Kapoor</a></p>
            <p className='copyright'>Copyright © 2021 by Monalika Kapoor</p>
        </div>
    )
}

export default Contact;